import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ConfirmationSociety from './ConfirmationSociety';
import { getSocietyList, setSocietyChoice } from 'store/features/society/actions';
import { AppDispatch, RootState } from 'store/types';

const mapStateToProps = (state: RootState) => ({
  ...state.society,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators({ getSocietyList, setSocietyChoice }, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationSociety);
